import Fertilizer from 'assets/images/farm/add/fertilzer.svg';
import Pesticide from 'assets/images/farm/add/pesticide.svg';
import Seed from 'assets/images/farm/add/seed.svg';
import Tools from 'assets/images/farm/add/tools.svg';
export const InputGroupsData: IInputGroup[] = [
  {
    id: 0,
    code: 11,
    icon: Fertilizer,
    isSelected: false,
    title: 'کود',
  },
  {
    id: 1,
    code: 12,
    icon: Pesticide,
    isSelected: false,
    title: 'سم',
  },
  {
    id: 2,
    code: 13,
    icon: Seed,
    isSelected: false,
    title: 'بذر',
  },
  {
    id: 3,
    code: 16,
    icon: Tools,
    isSelected: false,
    title: 'ادوات کشاورزی',
  },
];
